export const criminalContent = {
  theftRobbery: {
    en: {
      title: "Theft & Robbery Defense",
      subtitle: "Aggressive defense against theft and robbery charges in Texas",
      sections: [
        {
          title: "Protect Your Future from Theft Charges",
          content: "Theft and robbery charges range from misdemeanors to serious felonies. Whether you're facing shoplifting charges, burglary, or armed robbery allegations, our experienced criminal defense attorneys will fight to protect your rights and freedom."
        },
        {
          title: "Types of Theft Cases We Handle",
          items: [
            "Shoplifting & Petty Theft",
            "Burglary of Habitation or Vehicle",
            "Robbery & Aggravated Robbery",
            "Credit Card Fraud",
            "Identity Theft",
            "Embezzlement"
          ]
        }
      ],
      faq: [
        {
          question: "What's the difference between theft and robbery in Texas?",
          answer: "Theft involves taking property without the owner's consent. Robbery is theft with the added element of using force or threat of force against another person. Robbery is always a felony, while theft can be a misdemeanor or felony depending on the value."
        },
        {
          question: "Can theft charges be expunged in Texas?",
          answer: "It depends on the outcome of your case. If charges are dismissed, you're acquitted, or you complete deferred adjudication for certain offenses, you may be eligible for expunction or nondisclosure. We can help determine your eligibility."
        }
      ]
    },
    es: {
      title: "Defensa Contra Robo y Hurto",
      subtitle: "Defensa agresiva contra cargos de robo y hurto en Texas",
      sections: [
        {
          title: "Proteja su Futuro de Cargos de Robo",
          content: "Los cargos de robo y hurto van desde delitos menores hasta delitos graves serios. Ya sea que enfrente cargos de robo en tiendas, allanamiento o alegatos de robo a mano armada, nuestros abogados experimentados de defensa criminal lucharán para proteger sus derechos y libertad."
        },
        {
          title: "Tipos de Casos de Robo que Manejamos",
          items: [
            "Robo en Tiendas y Hurto Menor",
            "Allanamiento de Vivienda o Vehículo",
            "Robo y Robo Agravado",
            "Fraude con Tarjeta de Crédito",
            "Robo de Identidad",
            "Malversación de Fondos"
          ]
        }
      ],
      faq: [
        {
          question: "¿Cuál es la diferencia entre hurto y robo en Texas?",
          answer: "El hurto implica tomar propiedad sin el consentimiento del dueño. El robo es hurto con el elemento adicional de usar fuerza o amenaza de fuerza contra otra persona. El robo siempre es un delito grave, mientras que el hurto puede ser un delito menor o grave dependiendo del valor."
        },
        {
          question: "¿Se pueden eliminar los cargos de robo en Texas?",
          answer: "Depende del resultado de su caso. Si los cargos son desestimados, es absuelto, o completa adjudicación diferida para ciertas ofensas, puede ser elegible para expunción o no divulgación. Podemos ayudar a determinar su elegibilidad."
        }
      ]
    },
    vi: {
      title: "Bảo Vệ Trộm Cắp & Cướp",
      subtitle: "Bảo vệ mạnh mẽ chống lại cáo buộc trộm cắp và cướp tại Texas",
      sections: [
        {
          title: "Bảo Vệ Tương Lai Khỏi Cáo Buộc Trộm Cắp",
          content: "Các cáo buộc trộm cắp và cướp dao động từ tội nhẹ đến trọng tội nghiêm trọng. Cho dù bạn đang đối mặt với cáo buộc ăn cắp vặt, đột nhập hay cáo buộc cướp có vũ trang, các luật sư bảo vệ hình sự giàu kinh nghiệm của chúng tôi sẽ chiến đấu để bảo vệ quyền và tự do của bạn."
        },
        {
          title: "Các Loại Vụ Trộm Cắp Chúng Tôi Xử Lý",
          items: [
            "Ăn Cắp Vặt & Trộm Nhỏ",
            "Đột Nhập Nhà Ở hoặc Xe",
            "Cướp & Cướp Có Tình Tiết Tăng Nặng",
            "Gian Lận Thẻ Tín Dụng",
            "Trộm Danh Tính",
            "Biển Thủ"
          ]
        }
      ],
      faq: [
        {
          question: "Sự khác biệt giữa trộm cắp và cướp tại Texas là gì?",
          answer: "Trộm cắp liên quan đến việc lấy tài sản mà không có sự đồng ý của chủ sở hữu. Cướp là trộm cắp với yếu tố bổ sung là sử dụng vũ lực hoặc đe dọa vũ lực đối với người khác. Cướp luôn là trọng tội, trong khi trộm cắp có thể là tội nhẹ hoặc trọng tội tùy thuộc vào giá trị."
        },
        {
          question: "Có thể xóa cáo buộc trộm cắp tại Texas không?",
          answer: "Tùy thuộc vào kết quả của vụ án. Nếu cáo buộc bị bác bỏ, bạn được trắng án, hoặc hoàn thành phán quyết hoãn lại cho một số vi phạm, bạn có thể đủ điều kiện xóa hoặc không tiết lộ. Chúng tôi có thể giúp xác định tính đủ điều kiện của bạn."
        }
      ]
    }
  },
  sexCrimes: {
    en: {
      title: "Sex Crimes Defense Attorney",
      subtitle: "Confidential and aggressive defense for sex crime allegations",
      sections: [
        {
          title: "Serious Allegations Require Serious Defense",
          content: "Sex crime accusations can destroy your reputation, career, and freedom. These cases require immediate, strategic defense. Our attorneys handle sensitive cases with discretion while mounting an aggressive defense to protect your rights."
        },
        {
          title: "Sex Crime Cases We Defend",
          items: [
            "Sexual Assault",
            "Indecency with a Child",
            "Possession of Child Pornography",
            "Online Solicitation of a Minor",
            "Prostitution Charges",
            "Failure to Register as Sex Offender"
          ]
        }
      ],
      faq: [
        {
          question: "Will I have to register as a sex offender?",
          answer: "Not all sex crime convictions require registration. The requirement depends on the specific offense and circumstances. If registration is required, we can potentially negotiate alternative resolutions or fight the charges to avoid conviction."
        },
        {
          question: "How serious are sex crime charges in Texas?",
          answer: "Extremely serious. Most sex crimes are felonies carrying lengthy prison sentences, mandatory sex offender registration, and lifelong consequences. That's why immediate legal representation is critical."
        }
      ]
    },
    es: {
      title: "Abogado de Defensa de Delitos Sexuales",
      subtitle: "Defensa confidencial y agresiva para alegatos de delitos sexuales",
      sections: [
        {
          title: "Alegatos Serios Requieren Defensa Seria",
          content: "Las acusaciones de delitos sexuales pueden destruir su reputación, carrera y libertad. Estos casos requieren defensa inmediata y estratégica. Nuestros abogados manejan casos sensibles con discreción mientras montan una defensa agresiva para proteger sus derechos."
        },
        {
          title: "Casos de Delitos Sexuales que Defendemos",
          items: [
            "Asalto Sexual",
            "Indecencia con un Menor",
            "Posesión de Pornografía Infantil",
            "Solicitación en Línea de un Menor",
            "Cargos de Prostitución",
            "Falta de Registro como Delincuente Sexual"
          ]
        }
      ],
      faq: [
        {
          question: "¿Tendré que registrarme como delincuente sexual?",
          answer: "No todas las condenas por delitos sexuales requieren registro. El requisito depende del delito específico y las circunstancias. Si se requiere registro, podemos potencialmente negociar resoluciones alternativas o luchar contra los cargos para evitar la condena."
        },
        {
          question: "¿Qué tan serios son los cargos de delitos sexuales en Texas?",
          answer: "Extremadamente serios. La mayoría de los delitos sexuales son delitos graves que conllevan sentencias de prisión prolongadas, registro obligatorio como delincuente sexual y consecuencias de por vida. Por eso la representación legal inmediata es crítica."
        }
      ]
    },
    vi: {
      title: "Luật Sư Bảo Vệ Tội Phạm Tình Dục",
      subtitle: "Bảo vệ bí mật và mạnh mẽ cho cáo buộc tội phạm tình dục",
      sections: [
        {
          title: "Cáo Buộc Nghiêm Trọng Cần Bảo Vệ Nghiêm Túc",
          content: "Cáo buộc tội phạm tình dục có thể phá hủy danh tiếng, sự nghiệp và tự do của bạn. Những trường hợp này yêu cầu bảo vệ chiến lược ngay lập tức. Các luật sư của chúng tôi xử lý các vụ án nhạy cảm một cách kín đáo trong khi thực hiện bảo vệ mạnh mẽ để bảo vệ quyền của bạn."
        },
        {
          title: "Các Vụ Tội Phạm Tình Dục Chúng Tôi Bảo Vệ",
          items: [
            "Tấn Công Tình Dục",
            "Hành Vi Khiếm Nhã với Trẻ Em",
            "Sở Hữu Khiêu Dâm Trẻ Em",
            "Mời Chào Trực Tuyến Trẻ Vị Thành Niên",
            "Cáo Buộc Mại Dâm",
            "Không Đăng Ký Là Tội Phạm Tình Dục"
          ]
        }
      ],
      faq: [
        {
          question: "Tôi có phải đăng ký là tội phạm tình dục không?",
          answer: "Không phải tất cả các bản án tội phạm tình dục đều yêu cầu đăng ký. Yêu cầu phụ thuộc vào hành vi cụ thể và hoàn cảnh. Nếu yêu cầu đăng ký, chúng tôi có thể đàm phán các giải pháp thay thế hoặc chiến đấu chống lại các cáo buộc để tránh kết án."
        },
        {
          question: "Cáo buộc tội phạm tình dục tại Texas nghiêm trọng như thế nào?",
          answer: "Cực kỳ nghiêm trọng. Hầu hết các tội phạm tình dục là trọng tội với bản án tù dài, đăng ký bắt buộc là tội phạm tình dục, và hậu quả suốt đời. Đó là lý do tại sao đại diện pháp lý ngay lập tức là quan trọng."
        }
      ]
    }
  },
  expunction: {
    en: {
      title: "Expunction & Nondisclosure",
      subtitle: "Clear your criminal record and reclaim your future",
      sections: [
        {
          title: "Second Chances Through Record Clearing",
          content: "A criminal record can follow you for life, affecting employment, housing, and opportunities. Texas law allows for expunction (complete erasure) or orders of nondisclosure (sealing) of certain criminal records. We help determine your eligibility and guide you through the process."
        },
        {
          title: "Services We Provide",
          items: [
            "Eligibility Assessment",
            "Expunction Petitions",
            "Orders of Nondisclosure",
            "Juvenile Record Sealing",
            "DWI Expunctions",
            "Arrest Record Removal"
          ]
        }
      ],
      faq: [
        {
          question: "What's the difference between expunction and nondisclosure?",
          answer: "Expunction completely erases the record as if it never happened. Nondisclosure seals the record from public view but certain government agencies can still access it. Expunction is only available in specific situations (acquittal, dismissal, etc.)."
        },
        {
          question: "How long does the expunction process take?",
          answer: "Typically 4-6 months from filing to completion. The timeline depends on court schedules, whether the DA objects, and how quickly law enforcement agencies respond to the order."
        }
      ]
    },
    es: {
      title: "Expunción y No Divulgación",
      subtitle: "Limpie su récord criminal y recupere su futuro",
      sections: [
        {
          title: "Segundas Oportunidades a Través de la Limpieza de Récord",
          content: "Un récord criminal puede seguirlo de por vida, afectando el empleo, vivienda y oportunidades. La ley de Texas permite la expunción (borrado completo) u órdenes de no divulgación (sellado) de ciertos récords criminales. Ayudamos a determinar su elegibilidad y lo guiamos a través del proceso."
        },
        {
          title: "Servicios que Proporcionamos",
          items: [
            "Evaluación de Elegibilidad",
            "Peticiones de Expunción",
            "Órdenes de No Divulgación",
            "Sellado de Récord Juvenil",
            "Expunciones de DWI",
            "Eliminación de Récord de Arresto"
          ]
        }
      ],
      faq: [
        {
          question: "¿Cuál es la diferencia entre expunción y no divulgación?",
          answer: "La expunción borra completamente el récord como si nunca hubiera ocurrido. La no divulgación sella el récord de la vista pública pero ciertas agencias gubernamentales aún pueden acceder a él. La expunción solo está disponible en situaciones específicas (absolución, desestimación, etc.)."
        },
        {
          question: "¿Cuánto tiempo toma el proceso de expunción?",
          answer: "Típicamente 4-6 meses desde la presentación hasta la finalización. El cronograma depende de los horarios de la corte, si el fiscal se opone y qué tan rápido las agencias de aplicación de la ley responden a la orden."
        }
      ]
    },
    vi: {
      title: "Xóa Án & Không Tiết Lộ",
      subtitle: "Xóa hồ sơ hình sự của bạn và lấy lại tương lai",
      sections: [
        {
          title: "Cơ Hội Thứ Hai Thông Qua Xóa Hồ Sơ",
          content: "Hồ sơ hình sự có thể theo bạn suốt đời, ảnh hưởng đến việc làm, nhà ở và cơ hội. Luật Texas cho phép xóa án (xóa hoàn toàn) hoặc lệnh không tiết lộ (niêm phong) một số hồ sơ hình sự. Chúng tôi giúp xác định tính đủ điều kiện và hướng dẫn bạn qua quy trình."
        },
        {
          title: "Dịch Vụ Chúng Tôi Cung Cấp",
          items: [
            "Đánh Giá Tính Đủ Điều Kiện",
            "Đơn Xóa Án",
            "Lệnh Không Tiết Lộ",
            "Niêm Phong Hồ Sơ Vị Thành Niên",
            "Xóa Án DWI",
            "Xóa Hồ Sơ Bắt Giữ"
          ]
        }
      ],
      faq: [
        {
          question: "Sự khác biệt giữa xóa án và không tiết lộ là gì?",
          answer: "Xóa án hoàn toàn xóa hồ sơ như thể nó chưa bao giờ xảy ra. Không tiết lộ niêm phong hồ sơ khỏi công chúng nhưng một số cơ quan chính phủ vẫn có thể truy cập. Xóa án chỉ có sẵn trong các tình huống cụ thể (trắng án, bác bỏ, v.v.)."
        },
        {
          question: "Quá trình xóa án mất bao lâu?",
          answer: "Thường là 4-6 tháng từ khi nộp đến hoàn thành. Thời gian phụ thuộc vào lịch tòa án, liệu công tố viên có phản đối hay không và các cơ quan thực thi pháp luật phản hồi lệnh nhanh như thế nào."
        }
      ]
    }
  },
  dwi: {
    en: { title: "DWI/DUI Defense", subtitle: "Aggressive Defense Against Drunk Driving Charges in Texas", sections: [{ title: "DWI Defense in Texas", content: "A DWI conviction in Texas carries serious consequences: jail time, heavy fines, license suspension, increased insurance rates, and a permanent criminal record." }] },
    es: { title: "Defensa DWI/DUI", subtitle: "Defensa Agresiva Contra Cargos de Conducir Ebrio en Texas", sections: [{ title: "Defensa DWI en Texas", content: "Una condena por DWI en Texas conlleva consecuencias graves: tiempo en cárcel, multas elevadas, suspensión de licencia, aumento de tarifas de seguro y un registro criminal permanente." }] },
    vi: { title: "Bào Chữa DWI/DUI", subtitle: "Bào Chữa Mạnh Mẽ Chống Lại Cáo Buộc Lái Xe Say Ở Texas", sections: [{ title: "Bào Chữa DWI ở Texas", content: "Một bản án DWI ở Texas mang lại hậu quả nghiêm trọng: thời gian tù, tiền phạt nặng, đình chỉ bằng lái, tăng phí bảo hiểm và hồ sơ hình sự vĩnh viễn." }] }
  },
  assault: {
    en: { title: "Assault & Family Violence Defense", subtitle: "Aggressive defense against assault charges in Texas", sections: [{ title: "Assault Defense", content: "Protect your rights and freedom with experienced assault defense representation." }] },
    es: { title: "Defensa de Asalto y Violencia Familiar", subtitle: "Defensa agresiva contra cargos de asalto en Texas", sections: [{ title: "Defensa de Asalto", content: "Proteja sus derechos y libertad con representación experimentada en defensa de asalto." }] },
    vi: { title: "Bào Chữa Hành Hung & Bạo Lực Gia Đình", subtitle: "Bào chữa mạnh mẽ chống cáo buộc hành hung ở Texas", sections: [{ title: "Bào Chữa Hành Hung", content: "Bảo vệ quyền và tự do của bạn với đại diện bào chữa hành hung giàu kinh nghiệm." }] }
  },
  drugCharges: {
    en: { title: "Drug Charges Defense", subtitle: "Defense against drug possession and trafficking charges", sections: [{ title: "Drug Defense", content: "Experienced defense against all drug-related charges in Texas." }] },
    es: { title: "Defensa de Cargos de Drogas", subtitle: "Defensa contra cargos de posesión y tráfico de drogas", sections: [{ title: "Defensa de Drogas", content: "Defensa experimentada contra todos los cargos relacionados con drogas en Texas." }] },
    vi: { title: "Bào Chữa Cáo Buộc Ma Túy", subtitle: "Bào chữa chống cáo buộc sở hữu và buôn bán ma túy", sections: [{ title: "Bào Chữa Ma Túy", content: "Bào chữa giàu kinh nghiệm chống lại tất cả các cáo buộc liên quan đến ma túy ở Texas." }] }
  },
  violentCrimes: {
    en: { title: "Violent Crimes Defense", subtitle: "Defense against serious violent crime charges", sections: [{ title: "Violent Crime Defense", content: "Aggressive defense for murder, manslaughter, and other violent crime charges." }] },
    es: { title: "Defensa de Crímenes Violentos", subtitle: "Defensa contra cargos graves de crímenes violentos", sections: [{ title: "Defensa de Crímenes Violentos", content: "Defensa agresiva para asesinato, homicidio involuntario y otros cargos de crímenes violentos." }] },
    vi: { title: "Bào Chữa Tội Phạm Bạo Lực", subtitle: "Bào chữa chống cáo buộc tội phạm bạo lực nghiêm trọng", sections: [{ title: "Bào Chữa Tội Phạm Bạo Lực", content: "Bào chữa mạnh mẽ cho giết người, ngộ sát và các cáo buộc tội phạm bạo lực khác." }] }
  }
};
